<div class="not-found center">
      <h1>404</h1>
      <p>{{'_Shared_Error_Page_Not_Found_Text_' | translate }}</p>
      <p class="not-found-msg">{{'_Shared_Error_Page_Not_Found_Info_Text_' | translate }} 
            <a href="">support&#64;kronos.com</a>.</p>
      <button class="btn btn-primary" (click)="goToHome()">{{'_General_Button_Home_Text_' | translate }}</button>
</div>